import React, { useEffect, useState } from "react";
import API from "../api";
import Layout from "../components/Layout";
import { FaEdit, FaTrash } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/style.css";

const Stores = () => {
    const [stores, setStores] = useState([]);
    const [search, setSearch] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);

    const [editId, setEditId] = useState(null);


    // MODAL STATE
    const [showModal, setShowModal] = useState(false);

    const [form, setForm] = useState({
        name: "",
        location: "",
        phone: "",
        status: ""
    });

    useEffect(() => {
        fetchStores();
    }, []);

    const fetchStores = async () => {
        try {
            const res = await API.get("/stores");
            setStores(res.data);
        } catch (err) {
            console.log(err);
        }
    };


    // HANDLE INPUT
    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        });
    };

    // CREATE / UPDATE
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            if (editId) {
                await API.put(`/stores/${editId}`, form);
                toast.success("Store updated successfully");
            } else {
                await API.post("/stores", form);
                toast.success("Store created successfully");
            }

            setShowModal(false);
            setEditId(null);

            setForm({
                name: "",
                location: "",
                phone: "",
                status: ""
            });

            fetchStores();

        } catch (err) {
            toast.error("Something went wrong");
        }
    };

    // delete
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure to delete?")) return;

        try {
            await API.delete(`/stores/${id}`);
            toast.success("Store deleted");
            fetchStores();
        } catch (err) {
            toast.error("Delete failed");
        }
    };

    // EDIT
    const handleEdit = (store) => {
        setForm(store);
        setEditId(store._id);
        setShowModal(true);
    };

    // FILTER
    const filtered = stores.filter(s => {
        const keyword = search.toLowerCase();

        return (
            s.name?.toLowerCase().includes(keyword) ||
            s.location?.toLowerCase().includes(keyword) ||
            s.phone?.toLowerCase().includes(keyword)
        );
    });

    // PAGINATION
    const perPage = Number(limit);
    const start = (page - 1) * perPage;
    const current = filtered.slice(start, start + perPage);
    const totalPages = Math.ceil(filtered.length / perPage);

    return (
        <Layout>
            <ToastContainer position="top-right" autoClose={3000} />

            <div className="topbar">
                <h2>Stores</h2>
                <button className="add-btn" onClick={() => setShowModal(true)}>
                    + Add Store
                </button>
            </div>

            <div className="table-section">

                <div className="table-controls">
                    <div>
                        Show
                        <select value={limit} onChange={(e) => setLimit(e.target.value)}>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                        </select>
                        entries
                    </div>

                    <input
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>

                <div className="table-section">
                    <div className="table-responsive">
                        <table className="stores-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Location</th>
                                    <th>Phone</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>

                            <tbody>
                                {current.map((s) => (
                                    <tr key={s._id}>
                                        <td>{s.name}</td>
                                        <td>{s.location}</td>
                                        <td>{s.phone}</td>
                                        <td>
                                            <span className="status paid">
                                                {s.status}
                                            </span>
                                        </td>

                                        {/* ACTION BUTTONS */}
                                        <td className="actions">
                                            <button className="edit-btn" onClick={() => handleEdit(s)} ><FaEdit /></button>
                                            <button className="delete-btn" onClick={() => handleDelete(s._id)} ><FaTrash /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>


                    {/* PAGINATION */}
                    <div className="pagination">
                        <button disabled={page === 1} onClick={() => setPage(page - 1)}>Prev</button>

                        {Array.from({ length: totalPages }, (_, i) => (
                            <button
                                key={i}
                                className={page === i + 1 ? "active" : ""}
                                onClick={() => setPage(i + 1)}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button disabled={page === totalPages} onClick={() => setPage(page + 1)}>Next</button>
                    </div>

                </div>
            </div>

            {/* MODAL */}
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal">
                        <div className="modal-header">
                            <h3>{editId ? "Edit Store" : "Add Store"}</h3>
                            <span onClick={() => setShowModal(false)}>×</span>
                        </div>

                        <form onSubmit={handleSubmit}>
                            <input name="name" placeholder="Name" value={form.name} onChange={handleChange} required />
                            <input name="location" placeholder="Location" value={form.location} onChange={handleChange} required />
                            <input name="phone" placeholder="Phone" value={form.phone} onChange={handleChange} required />

                            <select name="status" value={form.status} onChange={handleChange}>
                                <option value="">Status</option>
                                <option value="Open">Open</option>
                                <option value="Closed">Closed</option>
                            </select>

                            <div className="modal-actions">
                                <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>
                                    Cancel
                                </button>
                                <button type="submit">
                                    {editId ? "Update" : "Create"}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </Layout >
    );
};

export default Stores;

